import styled from 'styled-components';
import { mediaSm } from '../../../theme/theme-helper-selectors';

export const FooterSocialsList = styled.div`
    padding: 10px 0;
    display: flex;
    flex-direction: row;

    @media (${mediaSm}) {
        gap: 15px;
    }
`;

export const FooterSocial = styled.a.attrs({
    target: '_blank',
    rel: 'noopener noreferrer',
})`
    margin-left: 10px;

    &:first-child {
        margin-left: 0;
    }

    @media (${mediaSm}) {
        svg {
            width: 50px;
            height: 50px;
        }
    }
`;
